import { render, staticRenderFns } from "./TopOfWeekFilters.vue?vue&type=template&id=e90fdfb0&"
import script from "./TopOfWeekFilters.vue?vue&type=script&lang=ts&"
export * from "./TopOfWeekFilters.vue?vue&type=script&lang=ts&"
import style0 from "./TopOfWeekFilters.vue?vue&type=style&index=0&id=e90fdfb0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports